import { chartColor } from '@/shared/lib/chart-theme';
import type { ChartData } from 'chart.js';

export const getDynamicChartScale = (
  values: number[],
  ticks = 4,
  padding = 0.1,
  maxCap?: number
) => {
  if (values.length === 0) {
    return { min: 0, max: 0, stepSize: 0 };
  }

  const min = Math.min(...values);
  const max = Math.max(...values);

  let calculatedMin = Math.floor(min * (1 - padding));
  let calculatedMax = Math.ceil(max * (1 + padding));

  if (maxCap !== undefined) {
    calculatedMax = Math.min(calculatedMax, maxCap);
  }

  const stepSize = Math.ceil((calculatedMax - calculatedMin) / ticks / 2) * 2;

  calculatedMin = Math.floor(calculatedMin / stepSize) * stepSize;
  calculatedMax = Math.ceil(calculatedMax / stepSize) * stepSize;

  if (maxCap !== undefined) {
    calculatedMax = Math.min(calculatedMax, maxCap);
  }

  return {
    min: calculatedMin,
    max: calculatedMax,
    stepSize,
  };
};

export const createDonutChartData = (
  values: number[],
  labels: string[]
): ChartData<'doughnut'> & { isEmpty?: boolean } => {
  const total = values.reduce((sum, v) => sum + v, 0);

  if (total === 0) {
    return {
      labels: ['No data'],
      datasets: [
        {
          data: [1],
          backgroundColor: [chartColor('--color-neutral-5')],
          hoverBackgroundColor: [chartColor('--color-neutral-5')],
          borderWidth: 0,
        },
      ],
      isEmpty: true,
    };
  }

  return {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: [
          chartColor('--color-polar-green-5'),
          chartColor('--color-calendula-gold-4'),
          chartColor('--color-dust-red-5'),
        ],
        hoverBackgroundColor: [
          chartColor('--color-polar-green-6'),
          chartColor('--color-calendula-gold-6'),
          chartColor('--color-dust-red-6'),
        ],
        borderWidth: 0,
      },
    ],
    isEmpty: false,
  };
};
